import { functions } from "@poseidon/firebase/firebase";
import { useState } from "react";
import { useHttpsCallable } from "react-firebase-hooks/functions";
import { AffordabilityReport } from "../pages/creditUnderwriting/affordabilityState";

export const useRunAffordabilityReport = (applicationId: string) => {
  const [executeCallable, loading, error] = useHttpsCallable(
    functions,
    "runAffordabilityReport"
  );
  const [complete, setComplete] = useState(false);
  const runReport = async () => {
    try {
      const response: {
        success: boolean;
        response: Partial<AffordabilityReport>;
      } = (await executeCallable({ applicationId }))?.data as any;

      if (response.success) {
        setComplete(true);
      }
    } catch (err) {
      console.error(err);
      setComplete(false);
    }
  };
  return {
    runReport,
    loading,
    error,
    success: !loading && !error && complete,
  };
};
